import { render } from "./SearchPatient.vue?vue&type=template&id=56c314c2&scoped=true"
import script from "./SearchPatient.vue?vue&type=script&lang=js"
export * from "./SearchPatient.vue?vue&type=script&lang=js"

import "./SearchPatient.vue?vue&type=style&index=0&id=56c314c2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c314c2"]])

export default __exports__